import { z } from 'zod';

import {
    CREATE_AB_TEST_ID,
    DEFAULT_TEASER_ID,
    SEO_TEASER_ID,
    SOCIAL_TEASER_ID,
    TEASER_VERSION_A_ID,
    TEASER_VERSION_B_ID,
} from './constants';

/** The teaser whose modal is open, which the routes that show the teasers pick */
export const teaserModalSearchParams = z.object({
    teaser: z
        .enum([
            DEFAULT_TEASER_ID,
            SEO_TEASER_ID,
            SOCIAL_TEASER_ID,
            TEASER_VERSION_A_ID,
            TEASER_VERSION_B_ID,
            CREATE_AB_TEST_ID,
        ])
        .optional()
        .catch(undefined),
    // Each tenant variant has its own teasers, except the SEO teaser
    teaserVariant: z.number().optional().catch(undefined),
});

export type TeaserModalSearchParams = z.output<typeof teaserModalSearchParams>;

export type TeaserId = NonNullable<TeaserModalSearchParams['teaser']>;
